var map = {
	"./cn.json": "94cd",
	"./cs.json": "8304",
	"./de.json": "7707",
	"./en.json": "ef66",
	"./es.json": "323b",
	"./fr.json": "0c67",
	"./it.json": "8296",
	"./jp.json": "ab4d",
	"./ko.json": "138f",
	"./pl.json": "64ed",
	"./ru.json": "af75",
	"./tr.json": "28ff",
	"./tw.json": "7f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caf4";